import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { MaxExpression } from "../../../rule-engine-core/Expressions/Expressions/Math/MaxExpression";

export class MaxExpressionEditor extends ExpressionRuleEditor<MaxExpression> {
    render() {
        return (
            <ExpressionPiece>
                max
                <BracketedDiv>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </BracketedDiv>
            </ExpressionPiece>
        );
    }
}
